export const STATUS_COLOR = {
  OPEN: "bg-blue-500 hover:bg-blue-600",
  ORDER_PLACED: "bg-blue-500 hover:bg-blue-600",
  PREPARING: "bg-orange-500 hover:bg-orange-600",
  BILL_PRINTED: "bg-purple-500 hover:bg-purple-600",
  PAID: "bg-gray-400 hover:bg-gray-500",
  CLOSED: "bg-green-600 hover:bg-green-700",
  FREE: "bg-green-500 hover:bg-green-600"
};
